import React, { Component } from 'react'
import { Modal, Button, Input } from 'hljd'
import { observer } from 'mobx-react'
import styles from './style.module.less'
import store from '../store'

@observer
export default class extends Component {
  render() {
    const { isUpgradeModalShow, main_shop_name } = store
    return (
      <Modal
        title="设置名称"
        visible={isUpgradeModalShow}
        width={560}
        onCancel={store.cancelUpgrade}
        afterClose={store.resetName}
        footer={[
          <Button key="back" onClick={store.cancelUpgrade}>
            放弃升级
          </Button>,
          <Button key="submit" type="primary" onClick={store.submitUpgrade}>
            确定
          </Button>
        ]}
      >
        <div className={styles.modalWrap}>
          <div className={styles.name}>商家名称：</div>
          <div className={styles.inputName}>
            <Input
              placeholder="请输入"
              onChange={store.changeMainShopName}
              value={main_shop_name}
            />
            <p style={{ marginTop: 10 }}>
              设置管理员账号的名称，建议使用公司名称，不要使用当前门店名称，以免混淆。
            </p>
          </div>
        </div>
      </Modal>
    )
  }
}
